import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-696b1797"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "customer-ranking-table" };
const _hoisted_2 = { class: "tbl-buttons" };
const _hoisted_3 = { class: "search-and-filter" };
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
    key: 1,
    class: "icon icon-search"
};
const _hoisted_6 = { class: "export-wrapper" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-download-18px" }, null, -1));
const _hoisted_8 = {
    key: 0,
    class: "export-container"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "tbl-shell" };
const _hoisted_11 = {
    ref: "tbl-config",
    class: "tbl-config"
};
const _hoisted_12 = {
    ref: "tableHeader",
    class: "tbl-header"
};
const _hoisted_13 = { class: "tbl-row" };
const _hoisted_14 = { class: "header-title" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
    key: 0,
    ref: "header-fixed",
    class: "tbl-header header-fixed"
};
const _hoisted_17 = { class: "tbl-row" };
const _hoisted_18 = { class: "header-title" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
    ref: "tbl-body",
    class: "tbl-body"
};
const _hoisted_21 = { class: "customer-ranking-pagination" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_loader = _resolveComponent("base-loader");
    const _component_info_card = _resolveComponent("info-card");
    const _component_list_pagination = _resolveComponent("list-pagination");
    const _component_lightbox_template = _resolveComponent("lightbox-template");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createBlock(_component_lightbox_template, {
        id: "lightbox-customer-ranking",
        title: _ctx.$t('customer-ranking-modal-title'),
        "show-date": false,
        icon: "customer"
    }, {
        default: _withCtx(() => [
            _createElementVNode("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.term) = $event)),
                            placeholder: _ctx.$t('search-table-input')
                        }, null, 8, _hoisted_4), [
                            [_vModelText, _ctx.term]
                        ]),
                        (_ctx.term !== '')
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "icon icon-close",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.clearTerm && _ctx.clearTerm(...args)))
                            }))
                            : (_openBlock(), _createElementBlock("i", _hoisted_5))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                            class: "btn secondary export-btn",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.toggleExport && _ctx.toggleExport(...args)))
                        }, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('export')), 1)
                        ]),
                        (_ctx.isExportVisible)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportItems, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.value,
                                        class: "items",
                                        onClick: ($event) => (_ctx.onChangeExport(item.value))
                                    }, _toDisplayString(item.title), 9, _hoisted_9));
                                }), 128))
                            ])), [
                                [_directive_click_outside, _ctx.toggleExport]
                            ])
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    (_ctx.verifyLoaded('done'))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref: "tbl-inner-wrapper",
                            class: "tbl-inner-wrapper customScrollBar",
                            onScroll: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.$_scrollTable && _ctx.$_scrollTable(...args)))
                        }, [
                            _createElementVNode("div", _hoisted_11, null, 512),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTableHeader, (vH, kH) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: kH,
                                            class: "tbl-col metric"
                                        }, [
                                            _createElementVNode("div", _hoisted_14, _toDisplayString(vH.name), 1),
                                            _createElementVNode("div", {
                                                ref_for: true,
                                                ref: vH.key,
                                                class: _normalizeClass([
                                                    `order-by ${vH.key}`,
                                                    {
                                                        active: _ctx.isActive === vH.key,
                                                    },
                                                ]),
                                                onClick: _withModifiers(($event) => (_ctx.ordenate(vH.key)), ["prevent"])
                                            }, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(['dash-arrows', `${/-/.test(_ctx.orderBy) ? 'desc' : 'asc'}`])
                                                }, null, 2)
                                            ], 10, _hoisted_15)
                                        ]));
                                    }), 128))
                                ])
                            ], 512),
                            (_ctx.headerFixed)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTableHeader, (vH, kH) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: kH,
                                                class: "tbl-col metric"
                                            }, [
                                                _createElementVNode("div", _hoisted_18, _toDisplayString(vH.name), 1),
                                                _createElementVNode("div", {
                                                    ref_for: true,
                                                    ref: vH.key,
                                                    class: _normalizeClass([
                                                        `order-by ${vH.key}`,
                                                        {
                                                            active: _ctx.isActive === vH.key,
                                                        },
                                                    ]),
                                                    onClick: _withModifiers(($event) => (_ctx.ordenate(vH.key)), ["prevent"])
                                                }, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(['dash-arrows', `${/-/.test(_ctx.orderBy) ? 'desc' : 'asc'}`])
                                                    }, null, 2)
                                                ], 10, _hoisted_19)
                                            ]));
                                        }), 128))
                                    ])
                                ], 512))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTableBody.rows, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "tbl-row"
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTableHeader, (vH, kH) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: kH,
                                                class: "tbl-col metric"
                                            }, [
                                                (vH.key === 'avg_products')
                                                    ? (_openBlock(), _createElementBlock("p", {
                                                        key: 0,
                                                        class: _normalizeClass([
                                                            'threshold',
                                                            `${_ctx.$_checkThreshold({
                                                                amount: item[vH.key],
                                                                threshold: vH.threshold,
                                                            })}`,
                                                        ])
                                                    }, _toDisplayString(_ctx.$_formatDecimal(item[vH.key])), 3))
                                                    : (_openBlock(), _createElementBlock("p", {
                                                        key: 1,
                                                        class: _normalizeClass([
                                                            'threshold',
                                                            `${_ctx.$_checkThreshold({
                                                                amount: item[vH.key],
                                                                threshold: vH.threshold,
                                                            })}`,
                                                        ])
                                                    }, _toDisplayString(_ctx.getValueNewFormat({ vH, amount: item[vH.key] })), 3))
                                            ]));
                                        }), 128))
                                    ]));
                                }), 128))
                            ], 512)
                        ], 544))
                        : _createCommentVNode("", true),
                    (_ctx.verifyLoaded('loading'))
                        ? (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                        : _createCommentVNode("", true),
                    (_ctx.verifyLoaded('info'))
                        ? (_openBlock(), _createBlock(_component_info_card, {
                            key: 2,
                            ref: "message-error",
                            error: _ctx.hasError
                        }, null, 8, ["error"]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_list_pagination, {
                    data: _ctx.pagination,
                    limit: _ctx.pagination.limit,
                    "limit-range": _ctx.limitRange,
                    identify: _ctx.identify
                }, null, 8, ["data", "limit", "limit-range", "identify"])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
